"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixCommaInDimension = fixCommaInDimension;
function fixCommaInDimension(tex) {
    return tex.replace(/(\\\\\[[^\]{]*){,}/g, "$1,");
}
